var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-xs h-6 w-6 flex items-center justify-center",attrs:{"type":"button"},on:{"click":_vm.share}},[_c('svg-icon',{staticClass:"w-full h-full",attrs:{"name":"share"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }